import { render, staticRenderFns } from "./Promocoes.vue?vue&type=template&id=4dcf555e&"
import script from "./Promocoes.vue?vue&type=script&lang=js&"
export * from "./Promocoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports